export class DateHelpers {
  static formatToRu(dateString?: string) {
    if (!dateString) return '-';
    const date = new Date(dateString);

    return new Intl.DateTimeFormat('ru-RU', {
      timeZone: 'Europe/Moscow',
      hour: 'numeric',
      minute: 'numeric',
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
    }).format(date);
  }
}
